/* CUSTOM_PROCHASE_BY_CLAUDE (ONYX 5658daa3e61b + 4432b1acdd03, Ryan 2026-10-01) - PICKUPS: YESTERDAY / TODAY /
   TOMORROW. Admin-only toolbar pill + modal over the worker's GET /pickups?from&to, the same route an agent
   holding `pickups.read` calls. One row per booked supplier leg: carrier, PRO, Load / BOL / pickup #,
   pickup confirmed, the customer email and whether its domain takes mail, which customer emails went
   (pickup-day, shipped-pending, tracking) or are queued, the PRO chase, and any [TEST] waiting on Ryan.
   Reads only; nothing here sends or writes. Self-contained on the dashboard-orders-inbox.js pattern. */
(function () {
  'use strict';
  window.RQD = window.RQD || {};

  function esc(s) { var d = document.createElement('div'); d.textContent = String(s == null ? '' : s); return d.innerHTML; }
  function day(offset) {
    var d = new Date(Date.now() + offset * 86400000);
    var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Denver', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
    return p;
  }
  function fmtWhen(s) {
    if (!s) return '';
    try { var d = new Date(s); if (isNaN(d.getTime())) return String(s).slice(0, 16); return d.toLocaleDateString(undefined, { month: 'numeric', day: 'numeric' }) + ' ' + d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }); }
    catch (e) { return String(s).slice(0, 16); }
  }

  function ready(cb) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (window.RepPortal && window.RepPortal.Auth && window.RepPortal.API) {
        var sess = null;
        try { sess = window.RepPortal.Auth.getSession(); } catch (e) { /* */ }
        if (sess) { clearInterval(t); cb(sess); return; }
      }
      if (tries > 100) clearInterval(t);
    }, 200);
  }

  ready(function (sess) {
    var isAdmin = !!(sess && (sess.admin === true || sess.role === 'admin'));
    if (!isAdmin) return;
    injectButton(window.RepPortal.API);
  });

  function injectButton(API) {
    if (document.getElementById('rqd-pickups-btn')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'rqd-pickups-btn';
    btn.className = 'rqd-pill';
    btn.style.cssText = 'white-space:nowrap;vertical-align:middle;';
    btn.textContent = 'Pickups';
    btn.title = 'Booked LTL pickups yesterday, today and tomorrow: carrier, PRO, and which customer emails went';
    btn.addEventListener('click', function () { openModal(API); });
    var after = document.getElementById('rqd-ordersinbox-btn') || document.getElementById('rqd-unlinked-btn') || document.getElementById('rqd-new-wrap');
    if (after && after.parentNode) {
      var sep = document.createElement('span');
      sep.className = 'rqd-sep';
      sep.textContent = '|';
      sep.setAttribute('aria-hidden', 'true');
      after.parentNode.insertBefore(sep, after.nextSibling);
      after.parentNode.insertBefore(btn, sep.nextSibling);
    } else {
      var bar = document.querySelector('.rqd-controls');
      if (bar) bar.appendChild(btn);
    }
  }

  /* One cell per customer email: what went, what is queued, what is waiting. */
  function emailsCell(r) {
    var e = r.emails || {};
    var out = [];
    if (e.pickupDay) out.push('📦 Pickup-day' + (e.pickupDay.noPro ? ' (no PRO)' : '') + ' ' + fmtWhen(e.pickupDay.at));
    if (e.offRail) out.push('✉ Other shipping email ' + fmtWhen(e.offRail.at));
    if (e.shippedNoPro) out.push('🚚 Shipped, tracking to follow ' + fmtWhen(e.shippedNoPro.at));
    if (e.tracking) out.push('✅ Tracking ' + fmtWhen(e.tracking.at));
    else if (e.trackingQueuedFor) out.push('⌛ Tracking queued for ' + fmtWhen(e.trackingQueuedFor));
    if (e.skipped) out.push('Skipped: ' + (e.skipped.reason || ''));
    if (!out.length) out.push('<span style="color:#b45309;">Nothing sent yet</span>');
    return out.map(function (x) { return '<div>' + (x.indexOf('<span') === 0 ? x : esc(x)) + '</div>'; }).join('');
  }
  function chaseCell(r) {
    var c = r.chase || {};
    var out = [];
    if (r.pro) return esc((r.trackingType || 'PRO') + ' ' + r.pro);
    if (c.proMissingAt) out.push('PRO missing: ' + (c.proMissingWhy || '') + (c.opsAsks && c.opsAsks.length ? ' · ops@ asked ' + c.opsAsks.length + 'x' : ''));
    else if (c.tmsWokeAt) out.push('Desk asked to read the BOL / TMS ' + fmtWhen(c.tmsWokeAt));
    else out.push('No PRO yet');
    return '<span style="color:#b45309;">' + esc(out.join(' ')) + '</span>';
  }

  function rowHtml(r) {
    var ids = [];
    if (r.loadNumber) ids.push('Load ' + r.loadNumber);
    if (r.bolNumber) ids.push('BOL ' + r.bolNumber);
    if (r.pickupNumber) ids.push('Pickup # ' + r.pickupNumber);
    var mail = r.customerEmail ? esc(r.customerEmail) + (r.customerEmailCheck === 'no-mail-server' ? ' <span style="color:#dc2626;font-weight:600;">no mail server</span>' : '') : '<span style="color:#dc2626;">no email on the deal</span>';
    var tdc = 'padding:6px 8px;border-top:1px solid var(--rq-border);vertical-align:top;font-size:12px;';
    return '<tr>'
      + '<td style="' + tdc + 'white-space:nowrap;"><a href="/pages/rep-quote-dashboard?ref=' + encodeURIComponent(r.ref) + '" style="font-weight:700;">' + esc(r.ref) + '</a><div style="color:var(--rq-text-secondary);">' + esc(r.vendor) + '</div></td>'
      + '<td style="' + tdc + '">' + esc(r.pickupDate) + (r.pickupConfirmedAt ? '<div style="color:#15803d;">picked up</div>' : '') + (r.deliveredAt ? '<div style="color:#15803d;">delivered</div>' : '') + '</td>'
      + '<td style="' + tdc + '">' + esc(r.carrier || '') + '<div style="color:var(--rq-text-secondary);">' + esc(ids.join(' · ')) + '</div></td>'
      + '<td style="' + tdc + '">' + chaseCell(r) + '</td>'
      + '<td style="' + tdc + '">' + mail + '</td>'
      + '<td style="' + tdc + '">' + emailsCell(r) + '</td>'
      + '</tr>';
  }

  function openModal(API) {
    var prior = document.getElementById('rqd-pickups-overlay');
    if (prior) prior.remove();
    var overlay = document.createElement('div');
    overlay.id = 'rqd-pickups-overlay';
    overlay.className = 'rqd-daterange-backdrop';
    overlay.innerHTML = [
      '<div class="rqd-daterange-modal" style="max-width:1080px;padding:22px 26px;max-height:88vh;display:flex;flex-direction:column;">',
      '  <h3 class="rqd-daterange-modal__title" style="margin-top:0;">Pickups: yesterday / today / tomorrow</h3>',
      '  <div id="rqd-pk-status" style="font-size:12px;color:var(--rq-text-secondary);margin-bottom:10px;">Loading…</div>',
      '  <div id="rqd-pk-list" style="overflow:auto;flex:1;min-height:120px;"></div>',
      '  <div class="rqd-daterange-modal__footer" style="margin-top:12px;">',
      '    <button type="button" id="rqd-pk-close" class="rqd-pill" style="margin-right:auto;">Close</button>',
      '  </div>',
      '</div>'
    ].join('\n');
    var mount = document.querySelector('.rep-quote-portal-wrap') || document.body;
    mount.appendChild(overlay);
    function close() { overlay.remove(); }
    overlay.querySelector('#rqd-pk-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (window.RepPortal.dismissedOnBackdrop && window.RepPortal.dismissedOnBackdrop(e, overlay)) close(); });

    var listEl = overlay.querySelector('#rqd-pk-list');
    var statusEl = overlay.querySelector('#rqd-pk-status');
    API.get('/pickups?from=' + day(-1) + '&to=' + day(1)).then(function (res) {
      if (!res || res.error) throw new Error((res && (res.detail || res.error)) || 'Could not read the pickups');
      var rows = res.rows || [];
      var sw = res.switches || {};
      statusEl.innerHTML = esc(rows.length + ' booked leg' + (rows.length === 1 ? '' : 's') + ', ' + res.from + ' to ' + res.to + '. ')
        + 'Customer pickup emails: <strong>' + (sw.customerEmails ? 'ON' : 'OFF') + '</strong> · GoRocket ops@ ask: <strong>' + (sw.opsAsk ? 'ON' : 'OFF') + '</strong>'
        + ((res.pendingTests || []).length ? ' · <span style="color:#b45309;">' + res.pendingTests.length + ' [TEST] waiting on you</span>' : '');
      if (!rows.length) { listEl.innerHTML = '<div style="padding:14px 4px;font-size:12px;color:var(--rq-text-secondary);">No pickups booked in that window.</div>'; return; }
      var th = 'text-align:left;padding:6px 8px;font-size:11px;color:var(--rq-text-secondary);font-weight:600;';
      listEl.innerHTML = '<table style="width:100%;border-collapse:collapse;">'
        + '<tr><th style="' + th + '">Deal</th><th style="' + th + '">Pickup</th><th style="' + th + '">Carrier</th><th style="' + th + '">PRO</th><th style="' + th + '">Customer</th><th style="' + th + '">Customer emails</th></tr>'
        + rows.map(rowHtml).join('') + '</table>'
        + ((res.pendingTests || []).length ? '<div style="margin-top:10px;font-size:12px;"><strong>Waiting on you:</strong> ' + res.pendingTests.map(function (t) { return esc(t.ref + ' ' + (t.testNumber ? '[TEST ' + t.testNumber + '] ' : '') + (t.subject || '')); }).join(' · ') + '</div>' : '');
    }).catch(function (err) {
      statusEl.textContent = '';
      listEl.innerHTML = '<div style="padding:14px 4px;font-size:12px;color:#dc2626;">' + esc((err && err.message) || 'Failed') + '</div>';
    });
  }
})();
/* END CUSTOM_PROCHASE_BY_CLAUDE */
